// Module
var code = "<div class=\"network-table row\"> <div id=\"export-container\"> <button class=\"button\" id=\"export-button\">Export</button> </div> <table> <thead> <tr> <th width=\"10%\">Time</th> <th width=\"10%\">Direction</th> <th width=\"70%\">Data</th> <th width=\"10%\"></th> </tr> </thead> <tbody> </tbody> </table> </div> ";
// Exports
export default code;